/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_NotesInputs */

const en_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const ar_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظات`)
};

const bn_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নোট`)
};

const de_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen`)
};

const es_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

const fr_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles`)
};

const pt_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

const zh_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记`)
};

const tr_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notlar`)
};

const ru_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заметки`)
};

const pl_nav_notes = /** @type {(inputs: Nav_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notatki`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Nav_NotesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_notes = /** @type {((inputs?: Nav_NotesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_NotesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_notes(inputs)
	if (locale === "bn") return bn_nav_notes(inputs)
	if (locale === "de") return de_nav_notes(inputs)
	if (locale === "es") return es_nav_notes(inputs)
	if (locale === "fr") return fr_nav_notes(inputs)
	if (locale === "pt") return pt_nav_notes(inputs)
	if (locale === "zh") return zh_nav_notes(inputs)
	if (locale === "tr") return tr_nav_notes(inputs)
	if (locale === "ru") return ru_nav_notes(inputs)
	if (locale === "pl") return pl_nav_notes(inputs)
	return en_nav_notes(inputs)
});